import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import AdvisorIcon from "components/Copilot/AdvisorIcon";
import styles from "./style.module.scss";

const AdvisorDataGate = ({ theme = "dark" }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={`${styles.planGate} ${styles[`planGate_${theme}`] || ""}`}>
      <AdvisorIcon className={styles.planGateIcon} size="lg" />
      <h1 className={styles.planGateTitle}>{t("cx_gpt.data_required_title")}</h1>
      <p className={styles.planGateBody}>{t("cx_gpt.data_required_body")}</p>
      <div className={styles.planGateActions}>
        <Button type="primary" onClick={() => history.push("/console/source")}>
          {t("cx_gpt.data_connect_sources")}
        </Button>
        <Button onClick={() => history.push("/console/myDashboards")}>
          {t("cx_gpt.data_view_dashboards")}
        </Button>
      </div>
      <p className={styles.planGateHint}>{t("cx_gpt.data_required_hint")}</p>
    </div>
  );
};

export default AdvisorDataGate;
